export default "__VITE_PUBLIC_ASSET__eafca6fb__"